import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"

// Sections
import HeroSection from "./sections/HeroSection"
import TrustBadgesSection from "./sections/PartnersSection"
import ServicesSection from "./sections/ServicesSection"
import WhyNettaSection from "./sections/WhyNettaSection"
import ProcessSection from "./sections/ProcessSection"
import StatsSection from "./sections/StatsSection"
import TestimonialsSection from "./sections/TestimonialsSection"
import CtaSection from "./sections/CtaSection"

const NettaHome = () => {
    const { t } = useTranslation()

    useEffect(() => {
        document.body.classList = ""
        document.querySelectorAll("#buyButton").forEach((navLink) => {
            navLink.classList.add("btn-light")
            navLink.classList.remove("btn-soft-primary")
            document.getElementById("top-menu")?.classList.add("nav-light")
        })
        window.addEventListener("scroll", scrollNavigation, true)

        return () => {
            window.removeEventListener("scroll", scrollNavigation, true)
        }
    }, [])

    const scrollNavigation = () => {
        var doc = document.documentElement
        var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0)
        if (top > 80) {
            document.querySelector(".shoppingbtn")?.classList.remove("btn-light")
            document.querySelector(".settingbtn")?.classList.remove("btn-light")
            document.querySelector(".shoppingbtn")?.classList.add("btn-primary")
            document.querySelector(".settingbtn")?.classList.add("btn-soft-primary")
            document.getElementById("topnav")?.classList.add("nav-sticky")
        } else {
            document.querySelector(".shoppingbtn")?.classList.remove("btn-primary")
            document.querySelector(".settingbtn")?.classList.remove("btn-soft-primary")
            document.querySelector(".shoppingbtn")?.classList.add("btn-light")
            document.querySelector(".settingbtn")?.classList.add("btn-light")
            document.getElementById("topnav")?.classList.remove("nav-sticky")
        }
    }

    return (
        <React.Fragment>
            {/* Hero Section */}
            <HeroSection />

            {/* Trust Badges - Security & Features */}
            <TrustBadgesSection />

            {/* Services Section */}
            <ServicesSection />

            {/* Why Netta Section */}
            <WhyNettaSection />

            {/* Process Section */}
            <ProcessSection />

            {/* Stats Section */}
            <StatsSection />

            {/* Testimonials Section */}
            <TestimonialsSection />

            {/* CTA Section */}
            <CtaSection />
        </React.Fragment>
    )
}

export default NettaHome
